import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import JoinLeagueForm, { JoinLeagueFormData } from 'components/join/JoinLeagueForm';

const defaultValues: JoinLeagueFormData = {
  name: '',
  email: '',
  phone: '',
  city: '',
};

function JoinLeagueSend() {
  const { t } = useTranslate('malyfotbal');
  const [error, setError] = useState<Error | undefined>(undefined);
  const [success, setSuccess] = useState(false);

  const send = async (data: JoinLeagueFormData) => {
    setError(undefined);
    setSuccess(false);

    const response = await fetch('/api/join/league', {
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      setError(new Error(result.error));
      return;
    }

    if (result.success) {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className='Form Form--center'>
        <h2>{t('join.league.form.success.title')}</h2>
        <p className='Form__message'>{t('join.league.form.success.message')}</p>
      </div>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      {error && <p>{error}</p>}
      <JoinLeagueForm onSubmit={send} values={defaultValues} />
    </GoogleReCaptchaProvider>
  );
}

export default JoinLeagueSend;
